<template>
  <div
    class="room"
    :class="{ active }"
    @drop="(onDrop($event, room.name), ($event.target as HTMLDivElement).classList.remove('dragover'))"
    @dragenter.prevent="($event.target as HTMLDivElement).classList.add('dragover')"
    @dragleave.prevent="($event.target as HTMLDivElement).classList.remove('dragover')"
    @dragover.prevent
  >
    <RoomHeader
      :name="room.name"
      @openRoomMenu="(name, event) => contextMenuRef?.openRoomContextMenu(event, name)"
      v-model:showRoom="showRoom"
    />
    <RoomUserList
      :name="room.name"
      :showRoom="showRoom"
      @openUserMenu="(name, event) => contextMenuRef?.openUserContextMenu(event, name)"
    />
    <RoomContextMenus ref="contextMenuRef" />
  </div>
</template>

<script lang="ts" setup>
import { computed, onBeforeUnmount, ref, useTemplateRef } from 'vue';
import { getApp } from '../models/App';
import { Room } from '../models/Room';
import { User } from '../models/User';
import RoomContextMenus from './RoomContextMenus.vue';
import RoomHeader from './RoomHeader.vue';
import RoomUserList from './RoomUserList.vue';

const props = defineProps<{ name: string }>();

const app = getApp();
const room = computed(() => Room.get(props.name) as Room);
const active = computed(() => app.connection.currentRoom === room.value);
const showRoom = ref(true);

const onDrop = (ev: DragEvent, name: string) => {
  const ids = ev.dataTransfer?.getData('text/plain') as string;
  const idArray = ids?.split(',') ?? [];

  const user = User.get(app.connection.id);

  if (!user) return;

  if (user.role === 'teacher' || (idArray.length === 1 && idArray[0] === user.id && user.permissions.rooms)) {
    idArray.forEach((id) => {
      // Deselect user on drop
      User.get(id)!.selected = false;
      app.send(`[switch]${id}:${name}`);
    });
  }
};

const contextMenuRef = useTemplateRef('contextMenuRef');

const nowRef = ref(Date.now());
let nowRefTimeout: ReturnType<typeof setTimeout> | undefined;
const updateNowRef = () => {
  nowRef.value = Date.now();
  nowRefTimeout = setTimeout(updateNowRef, 1000);
};

updateNowRef();

onBeforeUnmount(() => {
  clearTimeout(nowRefTimeout);
});
</script>

<style scoped>
div.room {
  padding: 6px;
  background: white;
}

div.room:first-child {
  padding-top: 12px;
}

div.room.active {
  background: var(--color-accent-room);
}

div.room.dragover {
  box-shadow: 0 0 10px inset #ddd;
}

div.room.dragover > * {
  pointer-events: none;
}
</style>
